import {GqlModel, GqlModelOperator, GqlQueryModel} from "../graphql/graphql.model";
import gql from "graphql-tag";
import {detectErrors} from "../http/common";

export class MigrateGqlModel extends GqlQueryModel {
  static mapper: GqlModelOperator<MigrateGqlModel> = GqlModel.buildMapper(MigrateGqlModel, "migrate");

  static query: any = gql`
    subscription migrate($projectId: ID!, $environment: String!) {
      migrate(projectId: $projectId, environment: $environment) {
        __typename
        ... on MigrationStatus {
          step
          steps
          status
        }
        ... on MigrationError {
          error
        }
      }
    }
  `;

  static variables(projectId: string, environment: string) {
    return {projectId, environment};
  }
}

export class MigrationStatusGqlModel extends MigrateGqlModel {
  step: number;
  steps: number;
  status: string;

  constructor(data: any) {
    super(data);
    data = data || {};

    this.step = +data.step;
    this.steps = +data.steps;
    this.status = data.status;
  }
}

export class MigrationErrorGqlModel extends MigrateGqlModel {
  error: Error;

  constructor(data: any) {
    super(data);
    data = data || {};

    if (typeof data.error === "string") data.error = JSON.parse(data.error);

    try {
      detectErrors(data);
    } catch (caught) {
      this.error = caught;
    }
  }
}

MigrateGqlModel.register("MigrationStatus", MigrationStatusGqlModel);
MigrateGqlModel.register("MigrationError", MigrationErrorGqlModel);
